module.exports = __webpack_public_path__ + "static/media/3DPPA39.9bd98426.jpg";